module.exports = __webpack_public_path__ + "static/media/setting-icon-blue.7e6341e8.svg";